import MStepper from './MStepper.vue';
import MStepperV2 from './MStepperV2.vue';

MStepper.install = (app) => {
  app.component('MStepper', MStepper);
};

MStepperV2.install = (app) => {
  app.component('MStepperV2', MStepperV2);
};
export { MStepper, MStepperV2 };
